"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.removedMfaFactor = exports.unsetUserOptions = exports.updatedUserOptions = exports.unsetUserShifts = exports.updatedUserShifts = void 0;
const initial_1 = __importDefault(require("@app/store/initial"));
const util_1 = require("@app/util");
const filter_1 = __importDefault(require("@app/util/filter"));
const toolkit_1 = require("@reduxjs/toolkit");
const action_type_1 = __importDefault(require("../const/action-type"));
const meSlice = (0, toolkit_1.createSlice)({
    name: 'me',
    initialState: initial_1.default.me,
    // CREATE YOUR REDUCERS HERE - EXTRA REDUCERS SHOULD BE USED ONLY FOR ACTIONS TARGETING MULTIPLE SLICES
    reducers: {
        updatedUserShifts: (_state, action) => {
            if (!(0, util_1.isValue)(_state.shifts)) {
                _state.shifts = [];
            }
            const existingIds = new Set(_state.shifts.map((shift) => shift.id));
            const newShifts = action.payload.filter((shift) => !existingIds.has(shift.id));
            _state.shifts.push(...newShifts);
        },
        unsetUserShifts: (_state) => {
            _state.shifts = undefined;
        },
        unsetUserOptions: (_state) => {
            _state.options = undefined;
        },
        updatedUserOptions: (_state, action) => {
            const _options = _state.options ?? [];
            if ((0, util_1.isUndefined)(_options)) {
                _state.options = action.payload;
                return;
            }
            action.payload.forEach((option) => {
                const optionIndex = _state.options?.findIndex((opt) => opt?.key === option.key);
                if ((0, util_1.isDefined)(optionIndex) && optionIndex >= 0) {
                    _options[optionIndex] = option;
                }
                else {
                    _options.push(option);
                }
            });
            _state.options = _options;
        },
        removedMfaFactor: (_state, action) => {
            if (!(0, util_1.isValue)(_state.mfa?.factors))
                return;
            _state.mfa.factors = _state.mfa.factors.filter((factor) => factor?.type !== action.payload);
            if (_state.mfa.factors.length === 0) {
                _state.mfa.enabled = false;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(action_type_1.default.RESET_STORE, (state) => {
            state = initial_1.default.me;
            return state;
        });
        builder.addCase(action_type_1.default.SET_ME, (state, payload) => {
            state = filter_1.default.objectWithoutKeys(payload.data, ['workspaces']);
            return state;
        });
    },
});
_a = meSlice.actions, exports.updatedUserShifts = _a.updatedUserShifts, exports.unsetUserShifts = _a.unsetUserShifts, exports.updatedUserOptions = _a.updatedUserOptions, exports.unsetUserOptions = _a.unsetUserOptions, exports.removedMfaFactor = _a.removedMfaFactor;
exports.default = meSlice.reducer;
